<template>
  <q-page padding class="row justify-center full-height full-width text-center">
    <div class="column flex-center text-center">
      <h4 class="q-my-none">Register</h4>
      <p class="q-my-md">To open an account with us please let us know a few details.</p>
      <form @submit.prevent.stop="register" @reset.prevent.stop="reset" class="q-gutter-y-md" style="width: 300px">
        <q-input v-model="loginFormData.email" type="email" label="Your Email"
                 class="q-pb-md" outlined
                 ref="emailInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 && validateEmail(val) || 'Please enter a valid email address.' ]"/>
        <q-input v-model="loginFormData.contactName" type="text" label="Your Name"
                 class="q-pb-md" outlined
                 ref="contactNameInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 || 'Please enter your name.' ]" />
        <q-input v-model="loginFormData.password" type="password" label="A Password"
                 class="q-pb-md" outlined
                 ref="passwordInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 7 || 'Please enter a password of at least 8 characters.' ]"/>
        <p class="q-mb-none float-left">
          <q-checkbox v-model="agreeTAC" label="I Agree to ICP's" class="q-pr-xs"/>
          <a href="../html-link.htm" target="popup" onclick="window.open('ClimbICP_Website Terms and Conditions_17 June 2019.pdf','name','width=600,height=800')">Terms and Conditions</a>
        </p>
        <p class="q-my-none float-left">
          <q-checkbox v-model="loginFormData.subscribeToEmails" label="Opt in to our email list." class="q-pr-xs">
            <q-tooltip content-style="font-size: 1em; width: 300px; opacity: 80%; background: black; "
                       anchor="center right" self="center left" :offset="[10, 10]"
                       transition-show="flip-right"
                       transition-hide="flip-down">The emails we send are all about getting incredible climbs into the hands of climbers (like you!). You can unsubscribe at any time.</q-tooltip>
          </q-checkbox>
        </p>
        <p v-show="registerError" class="text-red">
          {{registerErrorMessage}}
        </p>
        <q-btn type="submit" color="primary" class="full-width q-mx-md q-mt-sm q-mb-sm">Register</q-btn>
      </form>
      <p>
        <small><router-link to="/retail" class="text-primary">BACK</router-link></small>
      </p>
    </div>
  </q-page>
</template>

<script>
import gql from 'graphql-tag'
import { onLogin } from '../apollo/auth'

export default {
  name: 'PageRegisterRetail',
  data () {
    return {
      loginFormData: {
        email: '',
        password: '',
        contactName: '',
        postCode: '',
        subscribeToEmails: false
      },
      agreeTAC: false,
      registerError: false,
      registerErrorMessage: ''
    }
  },
  methods: {
    reset () {
      this.loginFormData.email = ''
      this.loginFormData.password = ''
      this.loginFormData.contactName = ''
      this.loginFormData.postCode = ''
      this.loginFormData.subscribeToEmails = false
      this.agreeTAC = false
      this.clearFormError()
    },
    validateEmail (email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    validateForm () {
      this.$refs.emailInput.validate()
      this.$refs.contactNameInput.validate()
      this.$refs.passwordInput.validate()
      return !(this.$refs.emailInput.hasError || this.$refs.contactNameInput.hasError ||
        this.$refs.passwordInput.hasError)
    },
    setFormError (message) {
      this.registerError = true
      this.registerErrorMessage = message
    },
    clearFormError () {
      this.registerError = false
      this.registerErrorMessage = ''
    },
    cartID () {
      return this.$store.state.auth.currentGuest.activeRetailCartId
    },
    trackRegister () {
      let cpy = Object.assign({}, this.loginFormData)
      delete cpy.password // Don't send the password to analytics!!
      // eslint-disable-next-line no-undef
      analytics.track('RegisterRetail', this.loginFormData)
    },
    async register () {
      if (!this.validateForm()) {
        this.setFormError('Please fix errors above.')
        return
      }
      if (!this.agreeTAC) {
        this.setFormError('Please accept our Terms and and Conditions.')
        return
      }
      try {  
        this.loginFormData.activeRetailCartId = this.cartID();
        this.loginFormData.postCode = "0000"
    
        const result = await this.$store.$apollo.mutate({
          mutation: gql`
            mutation ($input: RegisterRetailAccountInput!) {
              registerRetail(input: $input)
          }`,
          variables: {
            input: this.loginFormData
          }
        })
        this.trackRegister()
        // TODO: Would like a popup on login to say 'successfully registered'
        const token = result.data.registerRetail
        await onLogin(this.$apollo, token)
        await this.$store.dispatch('auth/init')
        await this.$store.dispatch('cart/init')
        await this.$store.dispatch('filters/fetchProductColours')
        // eslint-disable-next-line no-undef
        analytics.track('Login')
        // this.reset()
        this.$router.push('/retail')
      } catch (err) {
        console.log(err)
        if (err.networkError) {
          this.setFormError('Could not contact server')
        } else if (err.graphQLErrors && err.graphQLErrors.length) {
          this.setFormError(err.graphQLErrors[0].message)
        } else {
          this.setFormError('Error')
        }
      }
    }
  }
}
</script>
